@if (loadingPlaceholderText) {
  <p
    class="loading-placeholder-text"
    [class.centered]="centered"
    >
    {{ loadingPlaceholderText }}
  </p>
}

@if (shouldShow(1)) {
  <div class="section" [class.centered]="centered">
    @if (showEllipse) {
      <div class="ellipse"></div>
    }
    <div class="line w1"></div>
    <div class="content">
      <div class="line w2"></div>
      <div class="line w3"></div>
      <div class="line w4"></div>
    </div>
  </div>
}

@if (shouldShow(2)) {
  <div class="section" [class.centered]="centered">
    @if (showEllipse) {
      <div class="ellipse"></div>
    }
    <div class="line w9"></div>
    <div class="content">
      <div class="line btn-big"></div>
      <div class="line btn-small"></div>
      <div class="line btn-mid"></div>
    </div>
  </div>
}

@if (shouldShow(3)) {
  <div class="section" [class.centered]="centered">
    @if (showEllipse) {
      <div class="ellipse"></div>
    }
    <div class="line w5"></div>
    <div class="content">
      <div class="line w6"></div>
      <div class="line w7"></div>
      <div class="line w8"></div>
    </div>
  </div>
}

@if (shouldShow(4)) {
  <div class="section" [class.centered]="centered">
    @if (showEllipse) {
      <div class="ellipse"></div>
    }
    <div class="line w5"></div>
    <div class="content">
      <div class="line w7"></div>
    </div>
  </div>
}
